import { render, staticRenderFns } from "./InstructionCard.vue?vue&type=template&id=6e5d437e&scoped=true&"
import script from "./InstructionCard.vue?vue&type=script&lang=js&"
export * from "./InstructionCard.vue?vue&type=script&lang=js&"
import style0 from "./InstructionCard.vue?vue&type=style&index=0&id=6e5d437e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5d437e",
  null
  
)

export default component.exports